import { render, staticRenderFns } from "./oss-upload-img.vue?vue&type=template&id=fb1ae12e&"
import script from "./oss-upload-img.vue?vue&type=script&lang=js&"
export * from "./oss-upload-img.vue?vue&type=script&lang=js&"
import style0 from "./oss-upload-img.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports